module.exports = __webpack_public_path__ + "img/words6.511f1694.png";